export default "__VITE_ASSET__CFV4zQsv__"